//import 'three-hex-tiling';
import * as THREE from 'three';
import * as CANNON from 'cannon-es';

class PhysVisUtil {

	materialColor: any;
	solidMaterial: any;
	//THREE.ColorUtils.adjustHSV( solidMaterial.color, 0, 0, 0.9 );
	wireframeMaterial: any;
	currentMaterial: any;
	contactDotMaterial: any;
	particleMaterial: any;
	triggerMaterial: any;

	bodies: any[] = [];
	visuals: any[] = [];

	dummy = new THREE.Object3D();

	mountainMaterial: any;
	groundMaterial: any;
	roadMaterial: any;


	constructor() {
//		this.materialColor = 0xdddddd;
		this.materialColor = 0xffffdd;
//		this.solidMaterial = new THREE.MeshLambertMaterial({ color: this.materialColor });
this.solidMaterial = new THREE.MeshPhongMaterial({ color: this.materialColor });
this.solidMaterial.shininess = 100;
//this.solidMaterial.flatshading = true;

//this.solidMaterial = new THREE.MeshNormalMaterial();
///this.solidMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff, wireframe: true });


const loader = new THREE.TextureLoader();
//const texture = loader.load('/images/terrain_plain.png');
//let texture = loader.load('/images/stone-mountain-rock-2048x2048.jpg');
//let texture = loader.load('/images/sandstone-2048x2048.jpg');
//let texture = loader.load('/images/white-mountain-rock-2048x2048.jpg');
let texture = loader.load('/images/dirty-rock-2048x2048.jpg');
//let texture = loader.load('/images/rock-bark-mold-2048x2048.jpg');
this.mountainMaterial = new THREE.MeshPhongMaterial({ map: texture });
this.mountainMaterial.shininess = 100;


texture = loader.load('/images/terrain_plain.png');
//texture = loader.load('/images/dry-grass-ground-2048x2048.jpg');
//texture = loader.load('/images/red-sand-ground-2048x2048.jpg');
//texture = loader.load('/images/smooth-grass-2048x2048.jpg');
//texture = loader.load('/images/smooth-sand-dunes-2048x2048.jpg');
this.groundMaterial = new THREE.MeshLambertMaterial({ map: texture });


texture = loader.load('/images/Seamless-Road-Texture1.jpg');
this.roadMaterial = new THREE.MeshLambertMaterial({ map: texture });


/*
this.solidMaterial = new THREE.MeshStandardMaterial({
  map: texture,
  normalMap: myTextureNormalMap,
  roughnessMap: myTextureRoughnessMap,
  hexTiling: {
    // default values shown
    patchScale: 2,
    useContrastCorrectedBlending: true,
    lookupSkipThreshold: 0.01,
    textureSampleCoefficientExponent: 8,
  }
});
*/

		//THREE.ColorUtils.adjustHSV( solidMaterial.color, 0, 0, 0.9 );
		this.wireframeMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff, wireframe: true });
		this.currentMaterial = this.solidMaterial;
		this.contactDotMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff });
		this.particleMaterial = new THREE.MeshLambertMaterial({ color: 0xff0000 });
		this.triggerMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: true });
		
		//this.solidMaterial =this.wireframeMaterial; 
		
	}


	addVisual(parentObject: THREE.Object3D, body: CANNON.Body, type: string, name: string, shiftY: number) {

console.log("PhysUtil, addVisual, type = " + type);
console.log("PhysUtil, addVisual, name = " + name);

		// if it's a particle paint it red, if it's a trigger paint it as green, otherwise just gray
		const isParticle = body.shapes.every((s) => s instanceof CANNON.Particle);
		let material = isParticle ? this.particleMaterial : body.isTrigger ? this.triggerMaterial : this.currentMaterial;

		// get the correspondant three.js mesh
		if (name == "physTerrain") {
			material = this.wireframeMaterial;
		} else if (name == "mountains") {
			material = this.mountainMaterial;
		} else if (name == "ground") {
			material = this.groundMaterial;
///			material = this.wireframeMaterial;
		} else if (name == "road") {
			material = this.roadMaterial;
///			material = this.wireframeMaterial;
		} else if (type == "wheel") {
			material = this.wireframeMaterial;
		}  
		
		const mesh = this.bodyToMesh(body, material, type, name, shiftY);

console.log("PhysUtil, addVisual, mesh = " + mesh);

		// enable shadows on every object
/*
		mesh.traverse((child) => {
			child.castShadow = true;
			child.receiveShadow = true;
		})
*/
		this.bodies.push(body);
		this.visuals.push(mesh);

//			mesh.castShadow = true;
//			mesh.receiveShadow = true;

		parentObject.add(mesh);
	}
	///////////////////////////////////////////////////////////////////////////////////
	bodyToMesh(body: CANNON.Body, material: any, type: string, name: string, shiftY: number) {

console.log("PhysUtil, bodyToMesh, material = " + JSON.stringify(material));

		const group = new THREE.Group();

		group.position.copy(body.position);
		group.quaternion.copy(body.quaternion);

		const meshes = body.shapes.map((shape) => {
			const geometry = this.shapeToGeometry(shape, name, shiftY);

			const mesh: THREE.Mesh = new THREE.Mesh(geometry, material);  

			if (name == "heightfield") {
				mesh.receiveShadow = true;
				mesh.castShadow = true;
			}	

			return mesh;
		})

		meshes.forEach((mesh: THREE.Mesh, i: number) => {
			const offset = body.shapeOffsets[i];
			const orientation = body.shapeOrientations[i];
			mesh.position.copy(offset);
			mesh.quaternion.copy(orientation);
			
			if (name == "heightfield") {
				mesh.receiveShadow = true;
				mesh.castShadow = true;
			} else {
				mesh.castShadow = true;
			}

			group.add(mesh);
		})

		return group;
	}
	///////////////////////////////////////////////////////////////////////////////////
	shapeToGeometry(shape: any, name: string, shiftY: number, { flatShading = true } = {}) {
		
		console.log("shapeToGeometry, name = " + name);
		
		switch (shape.type) {
			case CANNON.Shape.types.SPHERE: {
				return new THREE.SphereGeometry(shape.radius, 8, 8);
			}

			case CANNON.Shape.types.PARTICLE: {
				return new THREE.SphereGeometry(0.1, 8, 8);
			}

			case CANNON.Shape.types.PLANE: {
				return new THREE.PlaneGeometry(500, 500, 4, 4);
			}

			case CANNON.Shape.types.BOX: {
				return new THREE.BoxGeometry(shape.halfExtents.x * 2, shape.halfExtents.y * 2, shape.halfExtents.z * 2);
			}

			case CANNON.Shape.types.CYLINDER: {
				return new THREE.CylinderGeometry(shape.radiusTop, shape.radiusBottom, shape.height, shape.numSegments);
			}
			/*
			case CANNON.Shape.types.CONVEXPOLYHEDRON: {
				const geometry = new THREE.BufferGeometry();

				// Add vertices
				for (let i = 0; i < shape.vertices.length; i++) {
					const vertex = shape.vertices[i];
					
					geometry.vertices.push(new THREE.Vector3(vertex.x, vertex.y, vertex.z));
				}

				// Add faces
				for (let i = 0; i < shape.faces.length; i++) {
					const face = shape.faces[i];

					const a = face[0];
					for (let j = 1; j < face.length - 1; j++) {
						const b = face[j];
						const c = face[j + 1];
						geometry.faces.push(new THREE.Face3(a, b, c));
					}
				}

				geometry.computeBoundingSphere();

				if (flatShading) {
/////					geometry.computeFaceNormals();
				} else {
					geometry.computeVertexNormals();
				}

				return geometry;
			}
			*/
			case CANNON.Shape.types.HEIGHTFIELD: {

console.log("PhysUtils, shape.type == CANNON.Shape.types.HEIGHTFIELD");
console.log("PhysUtils, shape.data.length = " + shape.data.length);

				const geometry = new THREE.BufferGeometry();

				const v0 = new CANNON.Vec3();
				const v1 = new CANNON.Vec3();
				const v2 = new CANNON.Vec3();

				//let index = 0;
				const points: THREE.Vector3[] = [];
				const uvs = [];

				for (let xi = 0; xi < shape.data.length - 1; xi++) {
					for (let yi = 0; yi < shape.data[xi].length - 1; yi++) {
						for (let k = 0; k < 2; k++) {
							shape.getConvexTrianglePillar(xi, yi, k === 0);
							v0.copy(shape.pillarConvex.vertices[0]);
							v1.copy(shape.pillarConvex.vertices[1]);
							v2.copy(shape.pillarConvex.vertices[2]);
							v0.vadd(shape.pillarOffset, v0);
							v1.vadd(shape.pillarOffset, v1);
							v2.vadd(shape.pillarOffset, v2);
							
//							uvs.push(0, 0, 0, 1, 1, 1);

							const divider = 1;
							
							// оставляю только рабочие треугольники карты высот дороги (оптимизация рендеринга)
							if (name == "road") {
								if ((v0.z == -200) || (v1.z == -200) || (v2.z == -200)) {
									continue;
								}
	
							} else if ((name == "mountains") || (name == "ground")) {
//								if ((v0.z == -300) || (v1.z == -300) || (v2.z == -300)) {
//									continue;
//								}
	
							}

							uvs.push(v0.x / shape.data.length % divider * 480/481 + 0.5/481, v0.y / shape.data[xi].length % divider * 480/481 + 0.5/481, 
								v1.x / shape.data.length % divider * 480/481 + 0.5/481, v1.y / shape.data[xi].length % divider * 480/481 + 0.5/481,
								v2.x / shape.data.length % divider * 480/481 + 0.5/481, v2.y / shape.data[xi].length % divider * 480/481 + 0.5/481);
							
							
							/*
							geometry.vertices.push(
								new THREE.Vector3(v0.x, v0.y, v0.z),
								new THREE.Vector3(v1.x, v1.y, v1.z),
								new THREE.Vector3(v2.x, v2.y, v2.z)
								);
							*/
							
//geometry.attributes.position.setXYZ( index++, v0.x, v0.y, v0.z );
//geometry.attributes.position.setXYZ( index++, v1.x, v1.y, v1.z );
//geometry.attributes.position.setXYZ( index++, v2.x, v2.y, v2.z );
//geometry.attributes.position.needsUpdate = true;
points.push(new THREE.Vector3(v0.x, v0.y + shiftY, v0.z));
points.push(new THREE.Vector3(v1.x, v1.y + shiftY, v1.z));
points.push(new THREE.Vector3(v2.x, v2.y + shiftY, v2.z));

//							const i = geometry.vertices.length - 3;
//							geometry.faces.push(new THREE.Face3(i, i + 1, i + 2));

						}
					}
				}

				geometry.setFromPoints(points);

//geometry.attributes.normal.needsUpdate = true;

				geometry.computeBoundingSphere();

console.log("flatShading = " + flatShading);

//				if (flatShading) {
//					geometry.computeFaceNormals();
//				} else {
					geometry.computeVertexNormals();
//				}


				const nUvComponents = 2;
				geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvs), nUvComponents));


				return geometry;
			}
			
			case CANNON.Shape.types.TRIMESH: {
				
				const geometry = new THREE.BufferGeometry();

				const v0 = new CANNON.Vec3();
				const v1 = new CANNON.Vec3();
				const v2 = new CANNON.Vec3();
				
				const points: THREE.Vector3[] = [];
				const uvs = [];				
				
				for (let i = 0; i < shape.indices.length / 3; i++) {
					shape.getTriangleVertices(i, v0, v1, v2);
					
					//geometry.vertices.push(
					//	new THREE.Vector3(v0.x, v0.y, v0.z),
					//	new THREE.Vector3(v1.x, v1.y, v1.z),
					//	new THREE.Vector3(v2.x, v2.y, v2.z)
					//);
					
					points.push(new THREE.Vector3(v0.x, v0.y + shiftY, v0.z));
					points.push(new THREE.Vector3(v1.x, v1.y + shiftY, v1.z));
					points.push(new THREE.Vector3(v2.x, v2.y + shiftY, v2.z));
					
					
					//const j = geometry.vertices.length - 3;
					//geometry.faces.push(new THREE.Face3(j, j + 1, j + 2));
					
					
					
					
				}

				geometry.setFromPoints(points);

				geometry.computeBoundingSphere();

				//if (flatShading) {
				//	geometry.computeFaceNormals();
				//} else {
					geometry.computeVertexNormals();
				//}

				return geometry;
			}
			
			default: {
				throw new Error(`Shape not recognized: "${shape.type}"`);
			}
		}
	}
	///////////////////////////////////////////////////
	updateVisuals() {
		for (let i = 0; i < this.bodies.length; i++) {
			const body = this.bodies[i]
			const visual = this.visuals[i]

			// Interpolated or not?
			let position = body.interpolatedPosition
			let quaternion = body.interpolatedQuaternion
			
			//if (this.settings.paused) {
				position = body.position
				quaternion = body.quaternion
			//}

			if (visual.isInstancedMesh) {
				this.dummy.position.copy(position)
				this.dummy.quaternion.copy(quaternion)

				this.dummy.updateMatrix()

				visual.setMatrixAt(body.instanceIndex, this.dummy.matrix)
				visual.instanceMatrix.needsUpdate = true
			} else {
				visual.position.copy(position)
				visual.quaternion.copy(quaternion)
			}
		}
		
	}
	///////////////////////////////////////////////////

}
export default PhysVisUtil;
